Pegasus.ThemesController = Em.ArrayController.extend({
});
